import React from "react";
import "../../../assets/fa-icons/css/fontawesome.css";
import "../../../assets/fa-icons/css/sharp-solid.css";
import { FontStyles } from "../../utils/font-styles.ts";
import { Divider } from "../../components/divider/divider.tsx";
import { SectionHeader } from "../../components/section-header.tsx";
import { focusStylesOutline } from "../../utils/focus-styles.ts";

export interface BranchListProps {
  branches: Branch[];
}

export interface Branch {
  id: number;
  imageUrl?: string | null;
  imageHighResUrl?: string | null;
  name: string;
  displayAddress: string;
  phoneNumber?: string | null;
}

const componentContainer = "flex flex-col gap-4.5 w-full";
const innerContainer = "flex flex-col md:flex-row md:items-center";
const imageContainer = "flex align-middle max-h-[400px] md:max-w-[20%] items-center self-center";
const imageStyle = "max-h-[300px] md:max-h-[150px]";
const branchInfoContainer =
  "flex flex-col gap-3.5 md:gap-3.5 self-stretch w-full pt-3.5 pb-3.5 md:pr-4.5 md:py-0 md:self-center";
const nameStyle = `text-slate font-medium ${FontStyles.h6} leading-snug md:leading-snug`;
const contactContainer = "flex gap-2 flex-col md:flex-row md:gap-5 flex-wrap";
const contactStyle = `text-slate ${FontStyles["body-l"]} leading-snug md:leading-snug flex gap-1.5 items-center`;

export const BranchList = (props: BranchListProps) => (
  <div className={componentContainer}>
    <SectionHeader text={"Branches"} as="h2" className={`leading-none md:leading-none ${FontStyles.h5}`} />
    {props.branches.map((b, index) => (
      <React.Fragment key={b.id}>
        <div className={innerContainer}>
          {b.imageUrl && b.imageHighResUrl ? (
            <div className={imageContainer}>
              <picture>
                <source media="(max-width: 767px)" srcSet={`${b.imageUrl} 1x, ${b.imageHighResUrl} 2x`} />
                <img className={imageStyle} src={b.imageUrl} alt={b.name} />
              </picture>
            </div>
          ) : null}
          <div className={`${branchInfoContainer} ${b.imageUrl ? "md:pl-4.5" : ""}`}>
            <div className={nameStyle}>{b.name}</div>
            <div className={contactContainer}>
              <div className={contactStyle}>
                <i className="fa-sharp fa-solid fa-building text-loch-400 pr-1.5 pb-0.5" />
                {b.displayAddress}
              </div>
              {b.phoneNumber != null && (
                <div className={contactStyle}>
                  <i className="fa-sharp fa-solid fa-phone text-loch-400 pr-1.5 pb-0.5" />
                  <a href={`tel:${b.phoneNumber}`} className={focusStylesOutline}>
                    {b.phoneNumber}
                  </a>
                </div>
              )}
            </div>
          </div>
        </div>
        {index < props.branches.length - 1 ? <Divider /> : null}
      </React.Fragment>
    ))}
  </div>
);
